import { render, staticRenderFns } from "./step-3.vue?vue&type=template&id=30b66c2a&scoped=true&"
import script from "./step-3.vue?vue&type=script&lang=js&"
export * from "./step-3.vue?vue&type=script&lang=js&"
import style0 from "./step-3.vue?vue&type=style&index=0&id=30b66c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b66c2a",
  null
  
)

export default component.exports